// GENERATED by scripts/build-icons.mjs from icons/circle-check.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const CheckCircle2 = createIcon('circle-check', [
  ['circle', { cx: "12", cy: "12", r: "10" }],
  ['path', { d: "m9 12 2 2 4-4" }],
])
